var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.images).length === 0)?_c('upload',{on:{"change":_vm.addImages}}):_c('quiz',{attrs:{"questions":_vm.images}})}
var staticRenderFns = []

export { render, staticRenderFns }